import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { Menu, LogOut, User, Building2 } from 'lucide-react';

const Header = ({ title, onMenuClick }) => {
  const { user, logout } = useAuth();

  return (
    <header
      className="sticky top-0 z-30 flex h-16 items-center gap-4 border-b border-white/5 bg-[var(--bg-page)]/70 backdrop-blur-sm px-6 lg:pl-72"
      data-testid="app-header"
    >
      {/* Mobile menu button */}
      <Button
        variant="ghost"
        size="icon"
        className="lg:hidden text-slate-300 hover:text-white hover:bg-white/10"
        onClick={onMenuClick}
        data-testid="header-menu-button"
      >
        <Menu className="h-5 w-5" />
      </Button>

      {/* Page title */}
      <h1 className="font-display text-xl font-semibold text-white" data-testid="header-title">
        {title}
      </h1>

      {/* Spacer */}
      <div className="flex-1" />

      {/* User menu */}
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            className="flex items-center gap-2 px-2 text-slate-200 hover:bg-white/10 hover:text-white"
            data-testid="user-menu-trigger"
          >
            <div
              className="h-8 w-8 rounded-full flex items-center justify-center p-[2px]"
              style={{ backgroundImage: 'linear-gradient(135deg, #3b82f6, #8b5cf6)' }}
            >
              <div className="h-full w-full rounded-full flex items-center justify-center" style={{ backgroundColor: 'var(--bg-card)' }}>
                <span className="text-sm font-medium text-white">
                  {user?.email?.[0]?.toUpperCase() || 'U'}
                </span>
              </div>
            </div>
            <span className="hidden sm:block text-sm font-medium text-slate-200">
              {user?.email}
            </span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel className="font-normal">
            <div className="flex flex-col space-y-1">
              <p className="text-sm font-medium text-white">{user?.email}</p>
              <p className="text-xs text-slate-400 capitalize">{user?.role}</p>
            </div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem className="flex items-center gap-2" data-testid="user-menu-profile">
            <User className="h-4 w-4" />
            Profile
          </DropdownMenuItem>
          <DropdownMenuItem className="flex items-center gap-2" data-testid="user-menu-company">
            <Building2 className="h-4 w-4" />
            {user?.company_name}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem 
            className="flex items-center gap-2 text-red-600 focus:text-red-600"
            onClick={logout}
            data-testid="user-menu-logout"
          >
            <LogOut className="h-4 w-4" />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  );
};

export default Header;
